import { Component } from '@angular/core';

@Component({
    selector: 'app-lovable-right-search',
    templateUrl: './lovable-right-search.component.html',
    styleUrls: ['./lovable-right-search.component.css'],
})
export class LovableRightSearchComponent {
    query = '';
}
